import React from "react";

const Historie = () => {
  return (
    <div>
      <h1>Historie skoly</h1>
      <p>nevimmm</p>
    </div>
  );
};

export default Historie;